













































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import AbpBase from '@/lib/abpbase'
    import Util from '@/lib/util'
    import PageRequest from '@/store/entities/page-request'
    import DateUtils from '@/common/js/DateUtils'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';
    import { routers } from '@/router/router'
    import moment from 'moment'
    class ExpressListRequest extends PageRequest {
        createTime?: Date;
        endTime?: Date;
        userCode: string;
        shipment: string;
        importNo: string;
        importType?: number;
        implementKind?: number;
        phone: string;
        constructor() {
            super();
            this.importType = null;

            this.implementKind = null;
        }
    }

    @Component({
        name:"expressImport",
    })
    export default class ImportExcel extends AbpBase {
        implementStatus = Enums.getEnum(Enums.ImplementType, true);
        importypeStatus = Enums.getEnum(Enums.importTypeStatus, true);

        headers: any = {
            "Authorization": "Bearer " + window.abp.auth.getToken(),
            ".AspNetCore.Culture": window.abp.utils.getCookieValue("Abp.Localization.CultureName"),
            "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie()
        };

        pagerequest: ExpressListRequest = new ExpressListRequest();
        createTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
        get list() {
            return this.$store.state.expressimport.list;
        };
        get loading() {
            return this.$store.state.expressimport.loading;
        }
        pageChange(page: number) {
            this.$store.commit('expressimport/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('expressimport/setPageSize', pagesize);
            this.getpage();
        }
        async getpage() {
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
             if (this.createTime.length > 0) {
                this.pagerequest.createTime = this.createTime[0];
            }
            if (this.createTime.length > 1) {
                this.pagerequest.endTime = this.createTime[1];
            }
            await this.$store.dispatch({
                type: 'expressimport/getAll',
                data: this.pagerequest
            });

        }
        async searchPage() {
            this.$store.state.expressimport.currentPage=1;
            this.getpage();
        }
        get pageSize() {
            return this.$store.state.expressimport.pageSize;
        }
        get totalCount() {
            return this.$store.state.expressimport.totalCount;
        }
        get currentPage() {
            return this.$store.state.expressimport.currentPage;
        }
        uploadURL: string = "";
        uploadURLs: string = "";
  

        handleSuccess(res, file) {
            if (res.success) {
                this.$Message.success('导入成功。');
            }
        }
        handleError(res, file) {
            this.$Message.error('导入失败。');
        }
       columns = [
          {
            title: '导入批次号',
            key: 'importNo',
            width: 180,

        },{
            title: '快递单号',
            key: 'shipment',
            width: 200,
            fixed: 'left',
        },{
            title: '用户编号',
            key: 'userCode',
            width: 150,
           }, {
               title: '手机号',
               key: 'phone',
               width: 150,
           }, {
               title: '货架号',
               key: 'shelfNumber',
               width: 120,
           },{
            title: '执行次数',
            key: 'executionNumber',
            width: 120,
        },{
            title: '执行类别',
            width: 142,
            key: 'implementKind',
                render: (h: any, params: any) => {
                    return h('span', Enums.ImplementType.filter(function (item) { return item.value == params.row.implementKind })[0].name);
            }
        },{
            title: '导入类型',
            width: 142,
            key: 'importType',
                render: (h: any, params: any) => {
                    return h('span', Enums.importTypeStatus.filter(function (item) { return item.value == params.row.importType })[0].name);
            }
        }, {
            title: '创建时间',
            key: 'createTime',
            width: 150,
            render: (h: any, params: any) => {
                return h('span', DateUtils.formatLongDate(new Date(params.row.createTime)));
            }
           }, {
               title: '业务时间',
               key: 'businessHours',
               width: 150,
               render: (h: any, params: any) => {
                   if (params.row.businessHours != null) {
                       return h('span', DateUtils.formatLongDate(new Date(params.row.businessHours)));
                   }
               }
           },{
            title: '开始执行时间',
            key: 'StartExecutionTime',
            width: 150,
               render: (h: any, params: any) => {
                   if (params.row.startExecutionTime != null) {
                       return h('span', DateUtils.formatLongDate(new Date(params.row.startExecutionTime)));
                   }
            }
        }, {
            title: '是否允许执行',
            key: 'whetherExecution',
            width: 120,
            render:(h:any,params:any)=>{
               return h('span',params.row.whetherExecution?this.L('是'):this.L('否'))
            }
        },{
            title: '最后错误描述',
            width: 190,
            key: 'finalErrorDesc',
        }
    ]

        async created() {
             this.uploadURL = appconst.remoteServiceBaseUrl + "api/services/app/ExpressImport/UploadExpress";
             this.uploadURLs = appconst.remoteServiceBaseUrl + "api/services/app/ExpressImport/UploadExpress";
             this.getpage();
        }
        /**按钮显示内容 */
        //  @Prop({ type: String, default: "" }) btnTitle: String;
    }
